export const NEW_NOTIFICATION = 'NEW_NOTIFICATION';
